/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Sync_Existing_SystemsInputs */



/**
* | output |
* | --- |
* | "Sync knowledge from existing systems" |
*
* @param {Onboarding_Usage_Sync_Existing_SystemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_sync_existing_systems = /** @type {((inputs?: Onboarding_Usage_Sync_Existing_SystemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Sync_Existing_SystemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissen aus bestehenden Systemen synchronisieren")
	return /** @type {LocalizedString} */ ("Sync knowledge from existing systems")
});